
<ng-container *ngIf="messages ; else noMessagesInGroup" > 
   <div class="text-muted small mt-3" placement="auto">
  </div>
  <vng-chat-message #msgRef [ngClass]="'vng-chat-message'" [conversation]="currentConversation" [message]="message" *ngFor="let message of messages"></vng-chat-message>
</ng-container>
<ng-template #noMessagesInGroup>
    <div class="d-flex flex-fill align-items-center flex-column text-center align-self-stretch h-100">
      <div class="my-auto text-muted">
        No messages in conversation
      </div>
    </div>
</ng-template>